import { createFileRoute } from '@tanstack/react-router'

import { PlatformOrganizationDashboardPage } from '../../../../components/pages/backoffice/platform/platform-organization-dashboard-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/$organizationTechnicalName/dashboard')({
  component: function Component() {
    const { organizationTechnicalName } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['organization.read']}>
        <PlatformOrganizationDashboardPage organizationTechnicalName={organizationTechnicalName} />
      </PermissionChecker>
    )
  },
})
